/**
 * Shared constants for the dashboard builder — widget catalog, chart
 * palette, and demo sample data. Kept in one place so the widget
 * renderer + palette + properties panel stay consistent.
 */
import {
  BarChart3, LineChart as LineChartIcon, PieChart as PieChartIcon,
  AreaChart as AreaChartIcon, Table, Hash, LayoutGrid, Image as ImageIcon,
} from 'lucide-react';

export const COLORS = ['#3b82f6', '#6366f1', '#f59e0b', '#10b981', '#ef4444', '#8b5cf6'];

export const WIDGET_TYPES = [
  { type: 'kpi', label: 'KPI Card', icon: Hash, defaultW: 3, defaultH: 2 },
  { type: 'bar_chart', label: 'Bar Chart', icon: BarChart3, defaultW: 6, defaultH: 4 },
  { type: 'line_chart', label: 'Line Chart', icon: LineChartIcon, defaultW: 6, defaultH: 4 },
  { type: 'area_chart', label: 'Area Chart', icon: AreaChartIcon, defaultW: 8, defaultH: 4 },
  { type: 'pie_chart', label: 'Pie Chart', icon: PieChartIcon, defaultW: 4, defaultH: 4 },
  { type: 'table', label: 'Data Table', icon: Table, defaultW: 6, defaultH: 4 },
  { type: 'image', label: 'Image / Logo', icon: ImageIcon, defaultW: 3, defaultH: 2 },
  // Iter D — trellis / small-multiples. Renders one mini-chart per
  // distinct value of `config.trellis_by`.
  { type: 'small_multiples', label: 'Small Multiples', icon: LayoutGrid, defaultW: 12, defaultH: 5 },
];

export const SAMPLE_DATA = {
  premium_trend: [
    { month: 'Jan', Auto: 52, Homeowners: 38, 'Commercial Property': 30 },
    { month: 'Feb', Auto: 48, Homeowners: 35, 'Commercial Property': 32 },
    { month: 'Mar', Auto: 55, Homeowners: 40, 'Commercial Property': 28 },
    { month: 'Apr', Auto: 50, Homeowners: 37, 'Commercial Property': 33 },
    { month: 'May', Auto: 53, Homeowners: 39, 'Commercial Property': 31 },
  ],
  loss_ratio: [
    { name: 'Auto', value: 68 },
    { name: 'Homeowners', value: 62 },
    { name: 'Commercial', value: 58 },
    { name: 'General Liability', value: 65 },
    { name: 'Workers Comp', value: 70 },
  ],
  claims_trend: [
    { month: 'Jan', claims: 1200, severity: 15400 },
    { month: 'Feb', claims: 1100, severity: 16200 },
    { month: 'Mar', claims: 1350, severity: 14800 },
    { month: 'Apr', claims: 1250, severity: 15900 },
    { month: 'May', claims: 1180, severity: 16500 },
  ],
};
